import {
  message,
} from 'antd';

export const openNotification = (type: 'success' | 'error' | 'loading' | 'warning', messageString: string) => {
  message[type](messageString);
};
